import { v4 as uuidv4 } from "uuid";
export function getRandomUUID() {
  return uuidv4();
}
